// extracted by mini-css-extract-plugin
export default {"ConsultantPanel":"MPPanel_ConsultantPanel__MlDHz","BottomBar":"MPPanel_BottomBar__hYEC7","Reviews":"MPPanel_Reviews__ExnFu","Badge":"MPPanel_Badge__hGKdK"};